import * as BoxType from '@/services/rest-api/lib/delivery/box-type';
import * as Vehicle from '@/services/rest-api/lib/fleet-task/vehicle';

export function tabelFilterFields(instance) {
  return [
    {
      name: 'box_type_id',
      isShow: true,
      label: 'Jenis Box',
      type: 'value-help-v2',
      placeholder: 'Pilih Jenis Box',
      trackBy: 'id',
      displayedBy: 'name',
      listGetter: BoxType.get,
      multiple: true,
      tableFields: [
        {
          label: 'Jenis Box',
          key: 'name',
          isSortable: true,
        },
      ],
    },
    {
      name: 'vehicle_id',
      isShow: true,
      label: instance.$t('fleetTask.fields.licensePlate'),
      type: 'value-help-v2',
      placeholder: instance.$t('fleetTask.placeholder.licensePlate'),
      trackBy: 'id',
      displayedBy: 'license_plate',
      listGetter: Vehicle.get,
      multiple: true,
      tableFields: [
        {
          label: instance.$t('fleetTask.fields.licensePlate'),
          key: 'license_plate',
          isSortable: true,
        },
        {
          label: instance.$t('fleetTask.fields.vehicleType'),
          key: 'vehicle_type.type',
          isSortable: true,
        },
      ],
    },
  ];
}
